import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ListBasic, {listColumns, listTitleSizes, listTypes} from '@adv-mt/mt-list-basic'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS, CHECK_ICON} from './config.js'

const PanelAdDetailsVehicleEquipment = ({optionalEquipment}) => {
  const {i18n} = useContext(Context)

  return (
    <div className={`${BASE_CLASS}-optionalEquipment`}>
      <TitleBasic
        as={titleBasicTags.h2}
        color={titleBasicColors.black}
        size={titleBasicSizes.xs}
        title={i18n.t('COMMON.EQUIPMENT.OPTIONAL_LABEL')}
      />
      {optionalEquipment.map(({title, descriptions}, i) => (
        <div className={`${BASE_CLASS}-optionalEquipmentGroup`} key={i}>
          <ListBasic
            icon={CHECK_ICON}
            items={descriptions}
            maxColumns={listColumns.M}
            title={title}
            titleColor={titleBasicColors.gray}
            titleSize={listTitleSizes.xxs}
            type={listTypes.ICON}
          />
        </div>
      ))}
    </div>
  )
}

PanelAdDetailsVehicleEquipment.propTypes = {
  optionalEquipment: PropTypes.object
}

export default PanelAdDetailsVehicleEquipment
